@if (demographicsDataService.demographicsVisibleSection()) {
    <div>
        @if (demographicsDataService.demographicsIsLoading()) {
            <div class="header-wrapper">
                <div class="column-center" style="padding: 25px 0">
                    <ev-logo-loader width="70px" />
                </div>
            </div>
        } @else {
            <div>
                @switch (demographicsDataService.demographicsVisibleSection()) {
                    @case (visibleSection.showData) {
                        <div class="header-wrapper">
                            <div class="demography-header grey">
                                <div class="column-center">
                                    <div class="column-center text-flow-end">
                                        <div class="uppercase-text primary-color">Hjemmelsoverganger</div>
                                        @if (useLastThreeYears) {
                                            <div class="uppercase-text secondary-color">siste tre år</div>
                                        }
                                    </div>
                                    <div class="extra-big-number">{{ demography?.numEstates | thousandize }}</div>
                                </div>

                                <div class="checkbox" (click)="changeUseLastThreeYears()">
                                    <div class="checkbox-icon" [class.selected]="useLastThreeYears"></div>
                                    <div class="label">Vis kun siste tre år</div>
                                </div>
                            </div>
                            <div class="row">
                                @if (!useLastThreeYears) {
                                    <div class="demography-header grey">{{ allEstateHeader?.header }}</div>
                                }
                                @if (useLastThreeYears) {
                                    <div class="demography-header grey">{{ lastYearsEstateHeader?.header }}</div>
                                }
                            </div>
                            <div class="extra-info-wrapper" (click)="showMoreInfo = !showMoreInfo" [class.extra-info-active]="showMoreInfo">
                                <div class="extra-info-header">
                                    <div class="extra-info-header-text">Mer info</div>
                                    <div class="expander-icon"></div>
                                </div>
                                @if (showMoreInfo) {
                                    <div class="extra-info-text">
                                        Velger man å inkludere kun hjemmelsoverganger siste 3 år, er det kun eiendommer som det er registrert hjemmelsoverganger
                                        med 100% eierskifte siste 3 år som inngår i statistikken. Filter på verdi vil gjelde salgspriser i kartmodus Marked, og
                                        estimert verdi i kartmodus Eiendom.<br /><br />
                                        <strong>Eksempel</strong><br />
                                        A og B kjøper en bolig sammen og tinglyser 50% eierandel hver for 5 år siden. B flytter ut og selger sin andel tilbake
                                        til A for 2 år siden. Denne boligen vil ikke være med i grunnlaget om man har valgt å kun inkludere hjemmelsoverganger
                                        siste 3 år.
                                    </div>
                                }
                            </div>
                        </div>
                        <div class="buyer-demography-info-wrapper">
                            @for (panel of statisticsPanels; track panel) {
                                <statistics-panel [panelData]="panel"></statistics-panel>
                            }
                            @if (!demography.isOnlyVacationHomes) {
                                <single-value [valuesData]="ownerNotOnAddress" [tooltip]="ownerNotOnAddressShareTooltip"></single-value>
                                <single-value [valuesData]="singleOwner" [tooltip]="singleOwnerShareTooltip"></single-value>
                                <single-value [valuesData]="firstTimeBuyers" [tooltip]="firstTimeBuyersShareTooltip"></single-value>
                            }
                            <buyer-origin
                                [graphData]="buyerOrigin"
                                [graphTotalNum]="graphTotalNum"
                                [isVacationHome]="demography.isOnlyVacationHomes"
                            ></buyer-origin>
                            @if (!demography.isOnlyVacationHomes) {
                                <div class="statistics-single-value bg-black">
                                    <div class="matrix-header">
                                        <div class="text">Endring i boligtype</div>
                                        <ev-arrow-choice [textDirection]="'right'" [options]="['%', 'Antall']" (change)="matrixDataDenominatorChanged($event)">
                                        </ev-arrow-choice>
                                        <div
                                            class="info-icon"
                                            (clickOutside)="changeMatrixTooltip.show = false"
                                            (click)="changeMatrixTooltip.show = !changeMatrixTooltip.show"
                                        >
                                            <ev_tooltip
                                                [visible]="changeMatrixTooltip.show"
                                                [left]="-270"
                                                [bottom]="27"
                                                [arrow]="'bottom'"
                                                [arrowBottomAlign]="-8"
                                                [arrowAlignRight]="17"
                                            >
                                                <div class="popup-info">
                                                    <div class="header">{{ changeMatrixTooltip.header }}</div>
                                                    @for (txt of changeMatrixTooltip.info; track txt) {
                                                        <div class="body">{{ txt }}</div>
                                                    }
                                                </div>
                                            </ev_tooltip>
                                        </div>
                                    </div>
                                </div>
                                <div class="matrix-wrapper bg-black">
                                    @for (column of matrixColumns; track column) {
                                        <div class="matrix-column">
                                            @for (
                                                type of ["Enebolig", "Tomannsbolig", "Rekkehus", "Leilighet", "unknown"];
                                                track type;
                                                let i = $index;
                                                let last = $last
                                            ) {
                                                @if (column?.number[i] > 0) {
                                                    <div class="cell">
                                                        <div [class]="'estate icon ' + type"></div>
                                                        @if (showNumbers) {
                                                            <div class="value">{{ column.number[i] }}</div>
                                                        }
                                                        @if (!showNumbers) {
                                                            <div class="value">{{ column.percent[i] }}<span class="grey small">%</span></div>
                                                        }
                                                    </div>
                                                    <div class="divider icon" [class.arrow]="last"></div>
                                                }
                                            }
                                            <div class="cell">
                                                <div [class]="'icon estate white ' + column.type"></div>
                                            </div>
                                            <div class="estate-class">{{ column.displayName || column.type }}</div>
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                    }
                    @case (visibleSection.showMixedEstatesWarning) {
                        <div class="demography-header warning-mixed-estates">
                            <div class="warning"></div>
                            <div class="text">Fritidsbolig kan ikke inkluderes med andre boligtyper</div>
                            <div class="text">Juster filteret til å kun vise fritidsbolig eller å kun vise alle andre boligtyper.</div>
                            <div class="illustration-estate-filter">
                                <div class="illustration-row">
                                    <div class="icon checkmark"></div>
                                    &nbsp;
                                    <div class="icon fritidsbolig"></div>
                                </div>
                                <div class="illustration-row">
                                    <div class="icon checkmark"></div>
                                    &nbsp;
                                    <div class="icon leilighet"></div>
                                    +
                                    <div class="icon enebolig"></div>
                                    +
                                    <div class="icon rekkehus"></div>
                                    +
                                    <div class="icon tomannsbolig"></div>
                                </div>
                                <div class="illustration-row">
                                    <div class="icon not-allowed"></div>
                                    &nbsp;
                                    <div class="icon leilighet"></div>
                                    +
                                    <div class="icon enebolig"></div>
                                    +
                                    <div class="icon rekkehus"></div>
                                    +
                                    <div class="icon tomannsbolig"></div>
                                    +
                                    <div class="icon fritidsbolig"></div>
                                </div>
                            </div>
                        </div>
                    }
                    @case (visibleSection.zoomIn) {
                        <div class="header-wrapper zoom-in-text">Zoom inn for &#229; vise statistikk</div>
                    }
                    @case (visibleSection.noData) {
                        <div class="demography-header bg-black">
                            <div class="column-container">
                                <div class="info-icon"></div>
                                <div>
                                    Ikke nok datapunkter til å vise statistikk. Prøv å utvide det valgte området i kartet eller endre/legg til boligtyper i
                                    filteret.
                                </div>
                            </div>
                        </div>
                    }
                    @case (visibleSection.limitReached) {
                        <div class="demography-header bg-black">
                            <div class="column-container">
                                <div class="info-icon"></div>
                                <div>
                                    Området du har valgt er for stort til å <br />generere demografi-statistikk. Reduser <br />antall områder eller størrelsen
                                    på området for å generere statistikk.
                                </div>
                            </div>
                        </div>
                    }
                    @default {
                        <div class="header-loader"><div>Default value should not be shown</div></div>
                    }
                }
            </div>
        }
    </div>
} @else {
    <div class="header-wrapper zoom-in-text">Zoom inn for &#229; vise statistikk</div>
}
